import { useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';

import { Field, RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { FetchState } from 'src/enums/FetchState';

import { fetchRequest } from 'src/utils/fetchRequest';

import LoginFormStyles from 'src/components/account/Login/_Fields/LoginFields.module.css';
import { ButtonWithLoader } from 'src/components/basicContent/_ButtonWithLoader/ButtonWithLoader';
import richTextStyles from 'src/components/basicContent/_RichText/RichText.module.css';

import { FormErrorBox } from '../_FormErrorBox/_FormErrorBox';

import styles from './_SecureSignInForm.module.css';

type SecureSignInFormProps = {
	usernamePattern: Field<string>;
	SecureLoginLinkIntroText: Field<string>;
	SecureLoginLinkUsernameLabel: Field<string>;
	SecureLoginLinkButtonText: Field<string>;
	SecureLoginLinkSuccessText: Field<string>;
	SecureLoginLinkErrorText: Field<string>;
};

export function SecureSignInForm(props: SecureSignInFormProps): JSX.Element {
	const [fetchState, setFetchState] = useState(FetchState.START);

	const { register, handleSubmit } = useForm();

	const form = useRef<HTMLFormElement>(null);

	const redirectUrl = useMemo(() => {
		return window.location.href;
	}, []);

	async function login(data: Record<string, unknown>) {
		if (!form.current) {
			return;
		}

		setFetchState(FetchState.LOADING);

		try {
			const response = await fetchRequest('/customapi/headlessauthentication/LogInSecureLinkForm', data);

			if (!response.ok) {
				setFetchState(FetchState.ERROR);
				throw response.statusText;
			}

			setFetchState(FetchState.SUCCESS);
		} catch (e) {
			setFetchState(FetchState.ERROR);
			console.log(e);
		}
	}

	return (
		<>
			{fetchState !== FetchState.SUCCESS ? (
				<div className={styles.section}>
					<RichText className={richTextStyles.richText} field={props.SecureLoginLinkIntroText as Field<string>} />
					<form className={LoginFormStyles.content} onSubmit={handleSubmit(login)} ref={form}>
						<input
							{...register('CopyItemId')}
							id="CopyItemId"
							name="CopyItemId"
							type="hidden"
							value="d10d948c-4a80-478c-bc42-e7058ed27786"
						/>

						<input {...register('RedirectUrl')} id="RedirectUrl" name="RedirectUrl" type="hidden" value={redirectUrl} />

						<label htmlFor="email">
							<Text
								tag="strong"
								field={props.SecureLoginLinkUsernameLabel}
								className={`${LoginFormStyles.labelText} ${LoginFormStyles.labelRequired}`}
							/>
						</label>

						<input
							{...register('email')}
							id="email"
							inputMode="email"
							pattern={props.usernamePattern?.value}
							className={`${LoginFormStyles.field} ${LoginFormStyles.fieldBordered}`}
							required
						/>

						<ButtonWithLoader type="submit" loginState={fetchState} className="button blueDark">
							<Text field={props.SecureLoginLinkButtonText} />
						</ButtonWithLoader>

						{fetchState === FetchState.ERROR && <FormErrorBox textField={props.SecureLoginLinkErrorText} />}
					</form>
				</div>
			) : (
				<RichText className={richTextStyles.richText} field={props.SecureLoginLinkSuccessText as Field<string>} />
			)}
		</>
	);
}
